import {mkPortfolioNeighborhoodId} from '@kapitalist/contract/types'

/**
 * A frontend-only `TPortfolioNeighborhoodData['id']` for a neighborhood that doesn't exist yet.
 *
 * NB: It used to cross the API to the backend in request bodies that always required an ID even
 * when the frontend couldn't give one, but we've since removed the need for that.
 */
export const BY_ITSELF_PORTFOLIO_NEIGHBORHOOD_ID = mkPortfolioNeighborhoodId(
  '00000000-0000-0000-0000-000000000000'
)
